import * as React from 'react';

import { ORG_ROLE_META } from '@/constants/orgRoles';
import { cn } from '@/lib/utils';
import type { OrgRole } from '@/types/orgMembers';

export interface RoleBadgeProps {
  role: OrgRole;
  className?: string;
}

/**
 * An organization role. Roles are not statuses, so this is not a
 * StatusBadge: each role has its own shape (◆ ◇ ○) and label, so it reads
 * the same without colour.
 */
export function RoleBadge({ role, className }: RoleBadgeProps) {
  const meta = ORG_ROLE_META[role];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium',
        meta.badgeClass,
        className
      )}
    >
      <span aria-hidden='true'>{meta.icon}</span>
      {meta.label}
    </span>
  );
}
